import { COLORS } from '../../constants';

const styles = () => ({
  heading: {
    textAlign: 'center',
    fontSize: '2rem',
    paddingTop: '2rem',
  },
  name: {
    margin: 'auto',
    fontSize: '2rem',
    textAlign: 'center',
  },
  nameContainter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },
  cross: {
    border: '1px solid black',
    padding: '3px 6px',
    borderRadius: '50%',
    cursor: 'pointer',
    marginLeft: 'auto',
  },
  searchBox: {
    marginBottom: '2rem',
  },
  tableContainer: {
    backgroundColor: COLORS.WHITE,
    margin: '2rem',
    padding: '1rem',
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: COLORS.GREEN,
    },
  },
  radioContainer: {
    margin: '10px 0',
  },
  inputDiv: {
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: '20px',
    paddingBottom: '20px',
    borderRadius: '5px',
    backgroundColor: COLORS.GREY,
  },
  imageContainer: {
    backgroundColor: '#F1F1F1',
    padding: '10px',
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px',
    marginTop: 10,
  },
  acceptButton: {
    backgroundColor: COLORS.GREEN,
    color: 'white',
    borderRadius: 0,
  },
  rejectButton: {
    borderRadius: 0,
    color: '#707070',
  },
  innercontainer: {
    position: 'relative',
    '& img': {
      width: '100%',
    },
  },
  checkIcon: {
    position: 'absolute',
    right: 10,
    top: 10,
    cursor: 'pointer',
  },
  radioGroup: {
    width: '100%',
    justifyContent: 'space-between',
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
  },
  paginationContainer: {
    margin: '25px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .button': {
      marginLeft: 15,
    },
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .button': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    '& svg': {
      margin: '0 15px',
    },
  },
  previous: {
    '& svg': {
      // display: 'flex',
      transform: 'rotate(180deg)',
    },
  },
  disabled: {
    color: 'lightgrey',
    cursor: 'initial !important',
    '& svg': {
      fill: 'lightgrey',
    },
  },
});

export default styles;
